// Thin wrapper around the GA4 gtag snippet loaded in public/index.html.
// All functions no-op when gtag is unavailable (tests, ad blockers).

function gtag(...args) {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag(...args);
  }
}

// Sends a page_view for an in-app section so GA4 can rank screens by views
// and average engagement time. page_location must change per screen for
// GA4 to attribute engagement time to the right page.
export function trackScreenView(screenId, screenTitle) {
  const path = screenId === 'home' ? '/' : `/${screenId}`;
  gtag('event', 'page_view', {
    page_title: screenTitle || screenId,
    page_path: path,
    page_location: typeof window !== 'undefined' ? `${window.location.origin}${path}` : path,
  });
}

export function trackEvent(name, params = {}) {
  gtag('event', name, params);
}
